module.exports = __webpack_public_path__ + "static/datamanProM-f108b6b3b7f5c0af87875a60c97c89ff.png";